type FormatType = 'currency' | 'percent';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const percentageFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 6,
  maximumFractionDigits: 6,
});

export const formatNumber = (value: number, formatType: FormatType): string => {
  if (Number.isNaN(value) || !Number.isFinite(value)) {
    return '-';
  }

  if (formatType === 'currency') {
    return currencyFormatter.format(value);
  }

  return percentageFormatter.format(value);
};
